export default __webpack_public_path__ + "static/media/redditDesk.6d0c92ea.svg";